export default __webpack_public_path__ + "static/mobile-banner-6d537c5a61b1aecb2ef58407621e5859.png";